import {request} from '../utils/request';

/**
 * 获取租户分页列表
 * @param {Object} data - 查询参数
 */
export const getTenantPageList = (data) => {
  return request({
    url: '/Tenant/GetPageList',
    method: 'post',
    data,
  });
};

/**
 * 获取租户详情
 * @param {number} id - 租户ID
 */
export const getTenantDetail = (id) => {
  return request({
    url: '/Tenant/GetDetail',
    method: 'get',
    params: { id },
  });
};

/**
 * 添加租户
 * @param {Object} data - 租户数据
 */
export const addTenant = (data) => {
  return request({
    url: '/Tenant/Add',
    method: 'post',
    data,
  });
};

/**
 * 更新租户
 * @param {Object} data - 租户数据
 */
export const updateTenant = (data) => {
  return request({
    url: '/Tenant/Update',
    method: 'post',
    data,
  });
};

/**
 * 更新租户状态
 * @param {Object} data - 状态数据
 * @param {number} data.Status - 状态
 * @param {Array<number>} data.Ids - 租户ID数组
 */
export const updateTenantStatus = (data) => {
  return request({
    url: '/Tenant/UpdateStatus',
    method: 'post',
    data,
  });
};

/**
 * 删除租户
 * @param {Object} data - 删除数据
 * @param {Array<number>} data.Ids - 租户ID数组
 */
export const deleteTenant = (data) => {
  return request({
    url: '/Tenant/Delete',
    method: 'post',
    data,
  });
};
